import React from 'react';

interface TickMarkProps {
  colorCode?: string;
  width?: number;
  height?: number;
  fillColor?: string;
  strokeColor?: string;
}

export const TickMark = ({
  colorCode = '#596C85',
  width = 20,
  height = 20,
  fillColor = '',
  strokeColor = '',
}: TickMarkProps): JSX.Element => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="11"
        cy="11"
        r="10.5"
        fill={fillColor ? fillColor : ''}
        stroke={strokeColor ? strokeColor : ''}
      />
      <path
        d="M6.97273 11.4734L9.77262 14.1957L15.7144 8.54362"
        stroke={colorCode}
      />
    </svg>
  );
};
